import { observer } from "mobx-react-lite";
import React, { FC } from "react";
import { langStore } from "@noli/business";
import styles from "./index.module.scss";
interface ContentBlockProps {
  title: string;
  children: React.ReactNode;
}
const ContentBlock: FC<ContentBlockProps> = (props) => {
  const lang = langStore.tgt;
  const { title, children } = props;
  return (
    <div className={styles.contentBlockWrapper}>
      <div className={styles.title}>{title}</div>
      {children}
    </div>
  );
};
export default observer(ContentBlock);
